import { Box, Typography } from '@mui/material';
import React from 'react';
import dataNotFound from '../../assests/dataNotFound.svg';
import palebuilder from '../../assests/pale-builder 1.svg';
import downloadSign from '../../assests/downloadSign.svg';
import { IMAGE_ALTERNATE_TEXT } from '../../shared/Strings';
import { ACTIVE_PRICE_LIST_PAGE } from '../../shared/constants';

const styles = {
  rootContainer: {
    width: '100%',
    background: '#FFFFFF',
    display: 'flex',
    padding: '64px 0px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    boxSizing: 'border-box',
  },
  textContainer: {
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& p:nth-of-type(1)': {
      fontFamily: 'Inter',
      fontSize: 20,
      fontWeight: 600,
    },
    '& p:nth-of-type(2)': {
      fontFamily: 'Inter',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.7,
      color: '#333333',
      maxWidth: 560,
    },
  },
  downloadTextContainer: {
    width: '100%',
    textAlign: 'center',
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& p:nth-of-type(1)': {
      fontFamily: 'Inter',
      fontSize: 20,
      fontWeight: 600,
    },
    '& p:nth-of-type(2)': {
      fontFamily: 'Inter',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.7,
      color: '#333333',
      maxWidth: 560,
    },
  },
};

const NotFound = ({
  sx,
  title,
  customText,
  priceList,
  download,
  onOpen,
  setHyperlinkClick,
  priceListFlag = false,
}) => {
  return (
    <Box sx={{ ...styles.rootContainer, ...sx }}>
      <img
        data-testid="img"
        src={priceList ? palebuilder : download ? downloadSign : dataNotFound}
        alt={IMAGE_ALTERNATE_TEXT.NOT_FOUND_ICON}
      />
      <Box sx={download ? styles.downloadTextContainer : styles.textContainer}>
        {title && (
          <Typography data-testid="title">
            {priceList
              ? ACTIVE_PRICE_LIST_PAGE.PriceListTitle
              : download
              ? ACTIVE_PRICE_LIST_PAGE.DownloadTitle
              : `No ${title} Found`}
          </Typography>
        )}
        {title && (
          <Typography component={'span'}>
            {priceList
              ? ACTIVE_PRICE_LIST_PAGE.PriceListText
              : download
              ? ACTIVE_PRICE_LIST_PAGE.DownloadText
              : priceListFlag
              ? `We couldn't find any ${title}. Please search with a different service, code or NPI.`
              : `We couldn't find any ${title} in your records.`}
          </Typography>
        )}
        {download && (
          <a
            style={{ textDecoration: 'none', color: '#036FCB' }}
            href=""
            onClick={e => {
              onOpen(e);
              setHyperlinkClick(true);
            }}>
            Download
          </a>
        )}
        {customText && (
          <Typography data-testid="custom" variant="navSelected">
            {customText}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default NotFound;
